<div class="modal-overlay" *ngIf="isOpen" (click)="closeModal($event)">
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-icon">
        <img alt="icon" *ngIf="icon" [src]="icon">
      </div>
      <h2 class="modal-title">{{ title }}</h2>
      <p class="modal-text">{{ text }}</p>

      <ng-content></ng-content>

      <div class="modal-buttons">
        <button class="modal-primary btn" *ngIf="primaryBtnText" (click)="primaryAction()">{{ primaryBtnText }}</button>
        <button class="modal-secondary" *ngIf="secondaryBtnText"
                (click)="secondaryAction()">{{ secondaryBtnText }}</button>
      </div>
    </div>
  </div>
</div>
